import { FC, useMemo, Fragment } from 'react';
import { Row } from 'antd';
import { isArray, isNotEmptyAny } from '@lhb/func';
import V2Title from '@/common/components/Feedback/V2Title';
// import V2Anchor from '@/common/components/Others/V2Anchor';
import PropertyComponent from './PropertyComponent';
import cs from 'classnames';
import styles from './index.module.less';
import { isShowWhenApprovalProcess } from './hooks/useAccessIsShow';
import { ControlType } from './config';

// const { Link } = Anchor;

/**
 * @Description 动态表单组件
 * 区分不同的组件类型
 * supportDirectApproval的说明 该字段是通用审批流中，用来控制字段的可读/可写
 */
const DynamicComponent: FC<{
  formData,
  wholeFormData,
  // anchorCustomStyle = {},
  // tabContentRefs,
  // active = '', // 目前处理在isLongList为true时才有用到
  // scrollAccordingTab = false, // 长列表tab点击时自动滚动，目前处理在isLongList为true时且初始化完成后手动点击时才为true
  // 以下参数单纯都是给PropertyCompoennt使用的
  form,
  isChancepoint?: boolean,
  /** 是否点位评估表单，是的话字段参照拓店模板设置，而不是流程配置 */
  isEvaluation?: boolean,
  /** 表单是否检查必填项，true检查，false只检查特定identification必填字段 */
  // needCheck: boolean,
  /** 是否长表单形式展示 */
  isLongList?: boolean,
  addressChange,
  /** 地图移动事件 */
  mapMoveChange?,
  /** 地图缩放事件 */
  mapZoomChange?,
  updateCompValue?,
  updateRelateShow,
  /** 是否支持直接提交审批 1:支持 2:不支持，默认值是2 */
  supportDirectApproval?,
  /** 在编辑状态下，踩点组件是否已有数据（已有数据则设置表单不可读） */
  isFootprintValue?: boolean,
  businessPlanValue?,
  businessInfoValue?,
  showHintStr?,
  /** 是否有区域保护 */
  isAreaProtect?,
  /** 机会点表单使用（卡旺卡预估销售额）,该组件还被其他页面引用，其他页面是不会传该参数 */
  salesFactorOfKWK?,
  /** 机会点表单使用（卡旺卡预估销售额） */
  setSalesFactorOfKWK?,
  isEditedBasicChancePointName?,
  setEditedBasicChancePointName?,
  tiledFormDataRef?,
  customGatheringCategoryForYHT?,
  setCustomGatheringCategoryForYHT?,
  /** 禁用开店区域点击查看详情 */
  disabledArea?,
  /** 是否编辑 */
  isEdit?: boolean,
  /** 拓店任务商圈id */
  expansionTaskClusterId?,
}> = ({
  formData,
  wholeFormData,
  // anchorCustomStyle = {},
  // tabContentRefs,
  // active = '', // 目前处理在isLongList为true时才有用到
  // scrollAccordingTab = false, // 长列表tab点击时自动滚动，目前处理在isLongList为true时且初始化完成后手动点击时才为true
  // 以下参数单纯都是给PropertyCompoennt使用的
  form,
  isChancepoint = true,
  isEvaluation = false, // 是否点位评估表单，是的话字段参照拓店模板设置，而不是流程配置
  // needCheck = true, // 表单是否检查必填项，true检查，false只检查特定identification必填字段
  isLongList = false, // 是否长表单形式展示
  addressChange,
  mapMoveChange, // 地图移动事件
  mapZoomChange, // 地图缩放事件
  updateCompValue,
  updateRelateShow,
  supportDirectApproval, // 是否支持直接提交审批 1:支持 2:不支持，默认值是2
  isFootprintValue = false, // 在编辑状态下，踩点组件是否已有数据（已有数据则设置表单不可读）
  businessPlanValue = {},
  businessInfoValue = {},
  showHintStr,
  isAreaProtect, // 是否有区域保护
  salesFactorOfKWK, // 机会点表单使用（卡旺卡预估销售额）,该组件还被其他页面引用，其他页面是不会传该参数
  setSalesFactorOfKWK, // 机会点表单使用（卡旺卡预估销售额）
  isEditedBasicChancePointName,
  setEditedBasicChancePointName,
  tiledFormDataRef,
  customGatheringCategoryForYHT,
  setCustomGatheringCategoryForYHT,
  disabledArea, // 禁用开店区域点击查看详情
  isEdit = false, // 是否编辑
  expansionTaskClusterId,
}) => {
  const { childList } = formData;


  /**
   * @description 是否是长列表展示时的第一group
   *    长列表时只有第一group下需要展示group的锚点
   * @return
   */
  const firstGroupOfLongList = useMemo(() => {
    return (isLongList && formData && isArray(wholeFormData.propertyGroupVOList) && wholeFormData.propertyGroupVOList.length && wholeFormData.propertyGroupVOList[0].id === formData.id);
  }, [wholeFormData, formData]);

  const anchorItems = useMemo(() => {
    if (firstGroupOfLongList) {
      // 长列表展示第一个tab时，将完整formData各tab下childList进行合并
      const items: any[] = [];
      wholeFormData.propertyGroupVOList.forEach((grp: any) => {
        isArray(grp.childList) && grp.childList.forEach((child: any) => {
          items.push({
            id: `title${child.id}`,
            title: child.name,
          });
        });
      });
      return items;
    }
    // 非长列表展示、或者长列表的第2个及以后group时，取tab下childList
    return childList.map((child: any) => ({
      id: `title${child.id}`,
      title: child.name,
    }));
  }, [childList]);

  // useEffect(() => {
  //   if (isLongList && scrollAccordingTab && active && +active === formData.id) {
  //     // 长表单tab切换时，自动滚动到tab对应内容
  //     // const element = document.getElementById(`group${formData.id}`);
  //     const targetEle = tabContentRefs.current.find((refItem) => refItem?.id === +active);
  //     targetEle?.el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //   }
  // }, [isLongList, active]);

  /**
   * @description 是否展示propertyList的二级标题
   * @param childItem 二级数据
   * @return 是否展示，默认true展示，如果第一项property是本身就带有小标题的特定组件就返回false不展示
   */
  const showSecondLevelTitle = (childItem: any) => {
    const firstItem = isArray(childItem?.propertyConfigVOList) ? childItem?.propertyConfigVOList[0] : null;

    // 匹配商圈有值时，展示的区域信息，或者周边测评信息，都是自带小标题，不展示二级标题，否则会出现连续展示两个标题的问题
    if (firstItem?.controlType === ControlType.MATCH_BUSINESS_CIRCLE.value) {
      /*
        匹配商圈组件的值
        未选地址时，textValue为null
        选地址不在区域内，textValue: "{\"lat\":30.283756,\"lng\":120.157653}"
        选地址在区域内，textValue: {"isInCluster":true,"clusterId":1052877,"planClusterId":null,"clusterName":"合肥凤凰文化广场","clusterTypeName":"商业区/商业体","clusterScore":"85.6","planStores":null,"openStores":0,"distance":20.57915686827509,"planSpots":null,"lat":31.809016,"lng":117.286636}
      */
      const valObj = JSON.parse(firstItem.textValue);
      const hasSelfTitle = typeof valObj === 'object' && isNotEmptyAny(valObj);
      return !hasSelfTitle;
    }

    // 基诺浦组件本身有小标题，处于第一个字段时不展示二级标题，否则会出现连续展示两个标题的问题
    const hide = firstItem?.controlType === ControlType.PROFIT_CAlCULATION_JNP.value;
    return !hide;
  };

  return (
    <div className={cs('dynamicComCon', styles.dynamicComponent)}>
      {
        isArray(childList) ? (<>
          {
            childList.map((childItem: any, index: number) => (isArray(childItem?.propertyConfigVOList) && childItem?.propertyConfigVOList.some(property => property.isShow && isShowWhenApprovalProcess({
              supportDirectApproval,
              propertyItem: property,
              isEvaluation,
              isChancepoint
            })) ? <Fragment key={index}>
                {showSecondLevelTitle(childItem) ? <V2Title
                  id={anchorItems[index].id}
                  type='H2'
                  divider
                  text={childItem.name}
                  className='pt-8 pb-16'
                /> : <></>}
                <Row gutter={24}>
                  {
                    isArray(childItem?.propertyConfigVOList)
                      ? childItem.propertyConfigVOList.map((item: any, idx: number) => <Fragment key={idx}>
                        <PropertyComponent
                          item={item}
                          form={form}
                          wholeFormData={wholeFormData}
                          isChancepoint={isChancepoint}
                          isEvaluation={isEvaluation}
                          addressChange={addressChange}
                          mapMoveChange={mapMoveChange}
                          mapZoomChange={mapZoomChange}
                          updateCompValue={updateCompValue}
                          updateRelateShow={updateRelateShow}
                          supportDirectApproval={supportDirectApproval}
                          isFootprintValue={isFootprintValue}
                          businessPlanValue={businessPlanValue}
                          businessInfoValue={businessInfoValue}
                          showHintStr={showHintStr}
                          isAreaProtect={isAreaProtect}
                          // addressVal={addressVal}
                          salesFactorOfKWK={salesFactorOfKWK}
                          setSalesFactorOfKWK={setSalesFactorOfKWK}
                          isEditedBasicChancePointName={isEditedBasicChancePointName}
                          setEditedBasicChancePointName={setEditedBasicChancePointName}
                          tiledFormDataRef={tiledFormDataRef}
                          customGatheringCategoryForYHT={customGatheringCategoryForYHT}
                          setCustomGatheringCategoryForYHT={setCustomGatheringCategoryForYHT}
                          disabledArea={disabledArea}
                          // onValuesChange={onValuesChange}
                          isEdit={isEdit}
                          expansionTaskClusterId={expansionTaskClusterId}
                        />
                      </Fragment>) : null
                  }
                </Row>

              </Fragment> : null))
          }
        </>) : null
      }

      {/* <V2Anchor
        getContainer={() => {
          // 长列表时关联包含了各tabs的dom，单tab内容时对应只包含该tab的dom
          const selectors: string = isLongList ? '.dynamicComponent' : '.dynamicComponent .dynamicComCon';
          const target: HTMLElement = document.querySelector(selectors) || document.body;
          // const target: HTMLElement = document.querySelector('.ant-drawer-content-wrapper .ant-drawer-body .dynamicComCon') || document.body;
          return target;
        }}
        className={cs(styles.anchorCon, anchorItems.length > 1 && (!isLongList || firstGroupOfLongList) ? '' : 'hide', isNotEmptyAny(anchorCustomStyle) ? '' : styles.defaultPostion)}
        style={isNotEmptyAny(anchorCustomStyle) ? anchorCustomStyle : {}}
      >
        { anchorItems.map(item => <Link key={item.id} href={`#${item.id}`} title={item.title} />) }
      </V2Anchor> */}
    </div>
  );
};

export default DynamicComponent;
